import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import TableSourceQueryGraphQL from './tablesource.query.graphql';
import TableControlGroup from '@/components/TableControlGroup/TableControlGroup.vue';
import { ITableGroup, ITableGroupColumn, ITableSection } from '@/interfaces/entities/table-group.interface';
import { toNumber } from '@/utils/convert';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableControlGroupReference',
  props: {
    tableSetId: {},
    selectedCode: {},
    displayCodes: {}
  },
  setup(__props: any) {

const props = __props;

const { result: queryResult } = useQuery(TableSourceQueryGraphQL, {
  path: props.tableSetId,
});

const tableSet = computed((): ITableGroup => {
  // Clone result to avoid read only error PSR-1186
  const tableSections = JSON.parse(JSON.stringify(queryResult.value?.item?.tableSections ?? []));
  return {
    tableSections: tableSections.map((section: any) => {
      return {
        heading: section.heading,
        showMoreButton: { value: toNumber(section.showMoreButton.value) },
        initialNumberOfItemsToShow: section.initialNumberOfItemsToShow,
        showMoreButtonText: section.showMoreButtonText,
        showLessButtonText: section.showLessButtonText,
        tableColumn: section.tableColumn
          .filter((column: any) => props.displayCodes.includes(column.code?.value ?? ''))
          .map((column: any) => {
            return {
              code: column.code,
              rows: column.rows.map((row: any) => {
                // Replace tokenized content
                row.heading?.rendered && (row.heading.value = row.heading.rendered);
                row.description?.rendered && (row.description.value = row.description.rendered);
                row.tooltipContent?.rendered && (row.tooltipContent.value = row.tooltipContent.rendered);
                return {
                  heading: row.heading,
                  description: row.description,
                  percentage: row.percentage,
                  tooltipContent: row.tooltipContent,
                };
              }),
              highlighted: column.code.value == props.selectedCode,
            } as ITableGroupColumn;
          }),
      } as ITableSection;
    }),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableControlGroup, { tableData: tableSet.value }, null, 8, ["tableData"]))
}
}

})